import { t } from 'i18next';

import { InviteType } from '~components/UserInvite/UserInviteTypeSelector';
import { Nullable } from '~types/Nullable';

interface ApplyInviteTypeErrorsArgs {
  clearEmailError: () => void;
  email: Nullable<string>;
  hasValidEmail: boolean;
  hasValidPhone: boolean;
  inviteTypes: InviteType[];
  setEmailError: (message: string) => void;
  setPhoneError: (message: string) => void;
}

/**
 * Route the "invite type requires a destination" error onto the channel(s) the
 * user picked.
 *
 * Returns true if an error was applied (caller should abort the submit).
 */
export function applyInviteTypeErrors({
  clearEmailError,
  email,
  hasValidEmail,
  hasValidPhone,
  inviteTypes,
  setEmailError,
  setPhoneError,
}: ApplyInviteTypeErrorsArgs): boolean {
  let hasError = false;

  if (inviteTypes.includes('sms') && !hasValidPhone) {
    if (!email && !inviteTypes.includes('email')) clearEmailError();
    setPhoneError(t('invite_type.phone_required'));
    hasError = true;
  }
  if (inviteTypes.includes('email') && !hasValidEmail) {
    setEmailError(t('invite_type.email_required'));
    hasError = true;
  }

  return hasError;
}
